export default __webpack_public_path__ + "ccfc3ac19f98a1f9ca1585d59b9a8dd5.svg";